import { EventStatusCode } from '../api/eventStatus.token';

export interface Agenda {
  agendaId: string;
  businessId: string;
  professionalId?: string | null;
  name: string;
  description?: string | null;
  color?: string | null;
  colorSoft?: string | null;
  createdAt?: string; // ISO
  updatedAt?: string | null;
}

export interface CreateAgendaDto {
  businessId: string;
  professionalId?: string;
  name: string;
  description?: string;
  color?: string;
}

export interface UpdateAgendaDto {
  // businessId: string;
  // professionalId?: string;
  name: string;
  description?: string;
  color?: string;
}

export enum RecurrenceFrequency {
  Daily = 0,
  Weekly = 1,
  Monthly = 2
}

export interface RecurrenceSettings {
  frequency: RecurrenceFrequency;
  daysOfWeek?: number[] | null; // For weekly: array of day of week (0=Sunday, 1=Monday, ..., 6=Saturday)
  endDate?: string | Date | null; // End date for recurrence (optional if occurrenceCount is set)
  occurrenceCount?: number | null; // Number of occurrences (optional if endDate is set)
}

export interface CreateAgendaEventDto {
  professionalId: string; // Changed from agendaId
  clientId: string;
  serviceId: string;
  statusId: string;
  startDate: string | Date;
  endDate: string | Date;
  notes?: string;
  paymentCompleted?: boolean;
  promotionId?: string | null;
  recurrence?: RecurrenceSettings | null;
  appointmentGroupId?: string | null;
}

export interface AgendaEvent {
  eventId: string;
  professionalId: string; // Changed from agendaId
  agendaId?: string; // Kept for backward compatibility
  clientId: string;
  serviceId: string;
  statusId: string;
  startDate: string; // ISO
  endDate: string; // ISO
  notes?: string | null;
  paymentCompleted?: boolean;
  promotionId?: string | null;
  promotionName?: string | null;
  promotionDiscountType?: 'percentage' | 'fixed' | string | null;
  promotionValue?: number | null;
  promotionAppliedAmount?: number | null;
  promotionRedeemed?: boolean;
  originalServicePrice?: number | null;
  finalPrice?: number | null;
  sessionPackageId?: string | null;
  sessionNumber?: number | null;
  totalSessions?: number | null;
  isPackageGenerated?: boolean;
  appointmentGroupId?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
  statusName: string;
  statusCode: EventStatusCode;
  professionalName: string; // Changed from agendaName
  professionalColor?: string; // Color of the professional
  agendaName?: string; // Kept for backward compatibility
  clientName: string;
  clientPhone: string | null;
  clientEmail: string | null;
  serviceName: string;
  serviceDescription: string;
  servicePrice: number;
  serviceDurationMinutes: number;
  color?: string;
  colorSoft?: string;
  deadLine?: string;
  origin?: string; // Calendar, Website, AiAgent
}

export interface UpdateAgendaEventDto {
  clientId?: string;
  serviceId?: string;
  statusId?: string;
  startDate?: string | Date; // ISO-UTC
  endDate?: string | Date;
  notes?: string;
  paymentCompleted?: boolean;
  professionalId?: string; // Changed from agendaId
  agendaId?: string; // Kept for backward compatibility
  promotionId?: string | null;
}

export interface GetAgendaEventsParams {
  agendaId?: string; // Kept for backward compatibility, maps to professionalId
  professionalId?: string;
  clientId?: string;
  startDate?: string | Date;
  endDate?: string | Date;
  statusCode?: string;
  businessId?: string;
}

export interface EventForReports {
  eventId: string;
  professionalId: string; // Changed from agendaId
  agendaId?: string; // Kept for backward compatibility
  clientId: string;
  serviceId: string;
  statusId: string;
  startDate: string;
  endDate: string;
  notes?: string | null;
  paymentCompleted: boolean;
  createdAt: string;
  updatedAt?: string | null;
  statusName: string;
  statusCode: string;
  professionalName: string; // Changed from agendaName
  agendaName?: string; // Kept for backward compatibility
  clientName: string;
  clientPhone?: string | null;
  clientEmail?: string | null;
  serviceName?: string | null;
  serviceDescription?: string | null;
  servicePrice?: number | null;
  serviceDurationMinutes?: number | null;
  /** Precio cobrado en la cita (con promoción); null en citas antiguas */
  finalPrice?: number | null;
  promotionId?: string | null;
  promotionName?: string | null;
  promotionDiscountType?: string | null;
  promotionValue?: number | null;
  promotionAppliedAmount?: number | null;
  promotionRedeemed?: boolean;
  sessionNumber?: number | null;
  totalSessions?: number | null;
}

export interface GetEventsForReportsParams {
  agendaId?: string;
  clientId?: string;
  startDate?: string | Date;
  endDate?: string | Date;
  statusCode?: string;
  businessId?: string;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  paymentCompleted?: boolean;
  serviceId?: string;
  professionalId?: string;
}

export interface GetEventsForReportsResponse {
  events: EventForReports[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export type EventVM = {
  id: string;
  clientName: string;
  clientEmail: string | null;
  professionalName: string; // Changed from agendaName
  agendaName?: string; // Kept for backward compatibility
  start: Date;
  end: Date;
  dateLine: string;
  statusCode: 'scheduled' | 'confirmed' | 'completed' | 'cancelled' | 'hidden';
  updatedAt?: Date | null;
};
